<template>
  <div class="centered-container">
    <PersonalDataTeaser />
    <LanguageTeaser />
    <!-- <PasswordTeaser /> -->
    <!-- <PlanTeaser /> -->
    <!-- <BillingTeaser /> -->
    <br />
    <Logout />
  </div>
</template>

<style lang="scss" scoped>
.centered-container {
  max-width: 600px;
  margin: 0 auto;
}
</style>

<script>
import PersonalDataTeaser from '@/components/User/PersonalDataTeaser.vue'
import LanguageTeaser from '@/components/User/LanguageTeaser.vue'
// import PasswordTeaser from "@/components/User/PasswordTeaser.vue";
// import PlanTeaser from "@/components/User/PlanTeaser.vue";
// import BillingTeaser from "@/components/User/BillingTeaser.vue";
import Logout from '@/components/User/Logout.vue'

export default {
  components: {
    PersonalDataTeaser,
    LanguageTeaser,
    // PasswordTeaser,
    // PlanTeaser,
    // BillingTeaser,
    Logout
  },
  mounted() {
    this.$store.dispatch('app/setSection', 'account')
    // Define window title
    this.$store.dispatch('app/setTitle', this.$i18n.t('account.pageTitle'))
  }
}
</script>
